import { render, staticRenderFns } from "./TemplateMessages.vue?vue&type=template&id=043bb4e3&scoped=true&"
import script from "./TemplateMessages.vue?vue&type=script&lang=js&"
export * from "./TemplateMessages.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMessages.vue?vue&type=style&index=0&id=043bb4e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043bb4e3",
  null
  
)

export default component.exports